export default {
  methods: {
    addClass: function (data) {
      if (!window.app.f7.online) {
        window.app.f7.dialog.alert('Device Offline!');
        return;
      }
      if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
        window.app.f7.dialog.alert('Please Sign In!');
        return;
      }
      window.pickerPop = window.open('/picker', '_blank');
    }
  },
  id: '0660fd14fd',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n<div class="page">\n    <div class="navbar">\n    <div class="navbar-bg"></div>\n    <div class="navbar-inner sliding">\n        <div class="left">\n        <a href="#" class="back link">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n        </a>\n        </div>\n        <div class="title">Add Class</div>\n    </div>\n    </div>\n    <div class="page-content">\n    <div class="block block-strong">\n    <div class="list no-hairlines-md">\n        <form class="list" id="addSheetIDBOX">\n        <ul>\n        <!-- <li>\n        <div class="item-content item-input">\n            <div class="item-inner">\n                <div class="item-title item-label">Google Sheets URL</div>\n                <div class="item-input-wrap">\n                <input name="url" type="text" placeholder="e.g. https://docs.google.com/spreadsheets/d/2yDuRYrRtOvjEm7b4sAfCC1Nr80VkkEuJ9b_nX25-C98/edit#gid=1827351863"/>\n                </div>\n            </div>\n        </div>\n        </li> -->\n        <li>\n        <div class="item-content item-input">\n        <div class="item-inner">\n            <div class="item-title item-label">Class Name (only visible to you)</div>\n            <div class="item-input-wrap">\n            <input name="alias" type="text" placeholder="e.g. Maths - CSE - Sem 1 - 2019"/>\n            </div>\n        </div>\n        </div>\n        </li>\n        </ul>\n        </form>\n        <div class="block">\n        <a href="#" class="col button button-large button-fill button-raised color-green" @click="addClass">Pick Spreadsheet & Add Class</a>\n        </div>\n    </div>\n    </div>\n    </div>\n</div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};